const editorSettings = {
  microModeScale: 40, // Angstroms To Pixels Factor
  macroModeScale: 40, // Angstroms To Pixels Factor
};

export function provideEditorSettings() {
  return editorSettings;
}
